/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;

	export class PhotoPin extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(data:ActivityPhoto, zoomLevel:number) {
			super(new THREE.Object3D());

			this.data = data;
			this.zoomLevel = zoomLevel;

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			const latLng:LatLng = this.data.getPosition();
			latLng.calcPixelCoord(this.zoomLevel);

			this.position = Unit.pixelElevationToSpace(latLng.getPixel(), this.data.getAltitude(), this.zoomLevel);

			this.pin = jQuery('#photo-pin-template').clone();
			jQuery('#photo-pin-container').append(this.pin);

			this.threeManager = ThreeManager.getInstance();
			this.screenPosition = new THREE.Vector3();

			this.update();

			return this.getView();
		}

		protected implReady():void {
		}

		protected implFinalize():void {
			this.data = null;
			this.pin = null;
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Command();
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Command();
		}

		public update():void {
			this.threeManager.project(this.position, this.screenPosition);
			this.pin.css({
				left: this.screenPosition.x,
				top: this.screenPosition.y,
				display: this.screenPosition.z > 1 ? 'none' : 'block',
			});
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private data:ActivityPhoto;

		private zoomLevel:number;
		private position:THREE.Vector3;

		private pin:JQuery;
		private threeManager:ThreeManager;
		private screenPosition:THREE.Vector3;
	}
}
